import UserGroupDetailModal from './user-group-detail-modal.vue'
export default UserGroupDetailModal
